import { useLoginContext } from '../hooks/useAuthentication';

function ClubPage() {
  const {detailsComponent} = useLoginContext();
  return detailsComponent?.() ?? null;
}

export default ClubPage;